import React, { useState } from "react";
import { Row, Col, message } from "antd";
import SectionCard from "../SectionCard";
import Button_v2 from "../Button_v2";
import AddOSDModal from "./AddOSDModal";
import OSDTable from "./OSDTable";
import { DeleteOsdDetails } from "../../../api/OrdersApi";
import { renderNotification } from "../../../components/orders/OrderTypeIcons";

const OSDSection = ({ currentOrder, warehouses, dtiversData, currentOrg, refreshDetails, osdRefreshKey, setOsdRefreshKey }) => {
  const [addOSD, setAddOSD] = useState(false);
  const [activeOsdFilter, setActiveOsdFilter] = useState("All");
  const [osdDetailsForFilter, setOsdDetailsForFilter] = useState([]);
  const [editingOsdRecord, setEditingOsdRecord] = useState(null);
  const [editingOsdIndex, setEditingOsdIndex] = useState(null);

  const bumpOsdRefreshKey = () => setOsdRefreshKey(prev => prev + 1);

  const handleDeleteOsd = async (record) => {
    const orderId = currentOrder?.id;
    const locationId = currentOrder?.locations?.[0]?.id;
    if (!orderId || !record?.id) return;

    try {
      const res = await DeleteOsdDetails(orderId, record.id, locationId);
      if (res?.success === false) {
        renderNotification(res?.errors?.[0] || "Failed to delete OSD detail.", "error");
        return;
      }
      message.success("OSD detail deleted successfully");
      refreshDetails?.();
      bumpOsdRefreshKey();
    } catch (e) {
      console.error(e);
      renderNotification("Error deleting OSD detail", "error");
    }
  };

  const handleEditOsd = (record, index) => {
    setEditingOsdRecord(record);
    setEditingOsdIndex(index);
    setAddOSD(true);
  };

  const handleCloseModal = () => {
    setEditingOsdRecord(null);
    setEditingOsdIndex(null);
    setAddOSD(false);
  };

  const statusCounts = {
    All: osdDetailsForFilter.length,
    Open: osdDetailsForFilter.filter(d => d.status === "OPEN").length,
    Reviewed: osdDetailsForFilter.filter(d => d.status === "REVIEW").length,
    Claim: osdDetailsForFilter.filter(d => d.status === "CLAIM").length,
    Closed: osdDetailsForFilter.filter(d => d.status === "CLOSED").length,
  };

  const filterTags = [
    { text: "All", value: statusCounts.All },
    { text: "Open", value: statusCounts.Open },
    { text: "Reviewed", value: statusCounts.Reviewed },
    { text: "Claim", value: statusCounts.Claim },
    { text: "Closed", value: statusCounts.Closed },
  ];

  return (
    <Row style={{ marginTop: 16 }}>
      <Col xs={24}>
        <SectionCard
          title="OSD Details"
          extraActionNode={
            <Button_v2
              data-testid="osd-button"
              type="secondary"
              className="outline small-btn"
              onClick={() => setAddOSD(true)}
              text="Add OSD"
            />
          }
        >
          <Row style={{ marginTop: "20px" }} gutter={[16, 16]}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Row>
                <Col span={24}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {filterTags.map((tag, index) => {
                    const isActive = activeOsdFilter === tag.text;
                    return (
                      <span key={index} onClick={() => setActiveOsdFilter(tag.text)} style={{
                        marginRight: "8px",
                        border: isActive ? "1px solid #586FCC" : "1px solid #C8D8E4",
                        borderRadius: "8px",
                        display: "flex",
                        minHeight: "24px",
                        padding: "2px 8px",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                        backgroundColor: isActive ? "#ECEFFE" : "none",
                        color: isActive ? "#586FCC" : "#1A354D"
                      }}>
                        {tag.text}
                        <span
                          style={{
                            display: "flex",
                            padding: "0px 5px",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "4px",
                            marginLeft: "8px",
                            border: isActive ? "1px solid #ACB8F9" : "1px solid #C8D8E4",
                            borderRadius: "8px",
                            backgroundColor: isActive ? "white" : "none",
                          }}
                        >
                          {tag.value}
                        </span>
                      </span>
                    );
                  })}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col xs={24}>
              <OSDTable
                orderId={currentOrder?.id}
                locationId={currentOrder?.locations?.[0]?.id}
                refreshKey={osdRefreshKey}
                activeFilter={activeOsdFilter}
                onDataChange={setOsdDetailsForFilter}
                onDelete={handleDeleteOsd}
                onEdit={handleEditOsd}
                warehouses={warehouses}
              />
            </Col>
          </Row>
        </SectionCard>
      </Col>

      <AddOSDModal
        visible={addOSD}
        onCancel={handleCloseModal}
        currentOrder={currentOrder}
        warehouses={warehouses}
        dtiversData={dtiversData}
        currentOrg={currentOrg}
        refreshDetails={() => {
          refreshDetails?.();
          bumpOsdRefreshKey();
        }}
        editingRecord={editingOsdRecord}
        editingOsdIndex={editingOsdIndex}
      />
    </Row>
  );
};

export default OSDSection;
